import React, { Component } from 'react';
import SidebarComponent from '../../components/sidebar/SidebarComponent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import Profile from '../../classes/profile'
import {
    fetchHomepageIfNeeded,
    setSelectedSidebarNav,
    logout
} from '../../actions'
import { LS_HOMEPAGE_KEY } from '../../constants/local_storage'
import { GlobalAttentionComponent } from '../../components/globalattention/GlobalAttentionComponent'
import {
  fetchAnticipationIndexIfNeeded,
  fetchTopContentIndexIfNeeded,
  fetchTrendingIndexIfNeeded,
  fetchCancelledShowsDetailsIfNeeded,
  setSelectedAttentionIndexDate,
  setSelecteddAttentionIndexView
} from '../../actions'
import { makeAnticipationIndexDetailsSelector, makeTopContentIndexDetailsSelector, makeTrendingIndexDetailsSelector, makeCancelledShowsIndexDetailsSelector } from '../../selectors'
import DateHelpers from '../../classes/DateHelpers'

import GlobalAttentionIndex from '../../testsupport/apiresults/GlobalAttentionIndex.json'
import GlobalAttention from '../../testsupport/apiresults/GlobalAttention.json'
import { ANTICIPATION_INDEX, TOP_CONTENT_INDEX, TRENDING_INDEX } from '../../constants/commons'

import NotFound from '../../components/NotFound'


class GlobalAttentionContainer extends Component {
    static propTypes = {
        isAdmin: PropTypes.bool.isRequired,
        anticipationDetails: PropTypes.object,
        topContentDetails: PropTypes.object,
        trendingDetails: PropTypes.object,
        cancelledShows: PropTypes.object,
        profile: Profile.PropTypes,
        history: PropTypes.object,
        match: PropTypes.object,
        topicId: PropTypes.string,
        homepage: PropTypes.object,
        audienceAcquisition: PropTypes.object,
        logout: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        topAndTrending: PropTypes.object,
        attentionIndex: PropTypes.object,
        shortcut: PropTypes.shape({
          id: PropTypes.string.isRequired,
          expires_at: PropTypes.string.isRequired,
          target: PropTypes.string.isRequired,
          target_id: PropTypes.string
        }),
        fetchHomepage: PropTypes.func.isRequired,
        fetchAnticipationIndexDetails: PropTypes.func,
        fetchTopContentIndexDetails: PropTypes.func,
        fetchTrendingIndexDetails: PropTypes.func,
        fetchCancelledShowsDetails: PropTypes.func,
        fetchGlobalAttentionScoreDetails: PropTypes.func,
        setSelectedAttentionIndexDate: PropTypes.func,
        setSelecteddAttentionIndexView: PropTypes.func,
        setShortcutPreference: PropTypes.func,
        shortcutPreference: PropTypes.string,
        selectedNav: PropTypes.string,
        isContentIntelligence: PropTypes.bool,
        isCatalogAnalysis: PropTypes.bool,
        isPerformanceAnalysis: PropTypes.bool,
        isAIInsights: PropTypes.bool,
        selectedSidebarNav: PropTypes.func,
        selectedDate: PropTypes.string,
        selectedView: PropTypes.string
    }

    constructor (props) {
      super(props)
      this.state = {
        anticipationDetails: {
          details: GlobalAttentionIndex,
          isFetching: false,
          error: null
        },
        attentionIndexDetails: {
          details: GlobalAttention,
          isFetching: false,
          error: null
        },
        engagementWeeks: []
      }
    }

    componentDidMount () {
      this.fetchData ()
    }

    getNumberOfPreviousWeekagoDate (currentDate, week) {
      const startOfCurrentWeek = new Date(currentDate);
      startOfCurrentWeek.setDate(currentDate.getDate() - currentDate.getDay() + (currentDate.getDay() === 0 ? -6 : 1));
      const previousWeeksAgo = new Date(startOfCurrentWeek);
      previousWeeksAgo.setDate(startOfCurrentWeek.getDate() - (week * 7));
      return previousWeeksAgo;
    }

    fetchData = () => {
      const homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
      if (!homepage) {
        if (this.props.profile && this.props.profile.groups.length > 0) {
          const groups = this.props.profile.groups
          const groupName = groups.filter(group => group !== 'Admin')[0]
          this.props.fetchHomepage(groupName)
        }
      }
      let previousWeekDate = this.getNumberOfPreviousWeekagoDate(new Date(), 1);
      const engagementWeeks = DateHelpers.getWeeksByDate(this.getNumberOfPreviousWeekagoDate(previousWeekDate, 8), previousWeekDate)
      this.setState({ engagementWeeks: engagementWeeks})
      setTimeout(() => {
        this.props.fetchTopContentIndexDetails(engagementWeeks[0].startDateOfWeek, engagementWeeks[0].endDateOfWeek)
        this.props.setSelectedAttentionIndexDate(engagementWeeks[0].startDateOfWeek+'_'+engagementWeeks[0].endDateOfWeek)
        this.props.setSelecteddAttentionIndexView(TOP_CONTENT_INDEX)
      }, 3000)
    }

    render () {
        const { profile, location, shortcut, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights, anticipationDetails, topContentDetails, trendingDetails, cancelledShows, selectedDate, selectedView, fetchAnticipationIndexDetails, fetchTopContentIndexDetails, fetchTrendingIndexDetails, fetchCancelledShowsDetails, setSelectedAttentionIndexDate, setSelecteddAttentionIndexView } = this.props
        let homepage = JSON.parse(localStorage.getItem(LS_HOMEPAGE_KEY))
        homepage = homepage ? homepage : this.props.homepage
        const myLogout = () => this.props.logout()

        return (
          <>
            <SidebarComponent
              isAdmin={this.props.isAdmin}
              profile={profile}
              logout={myLogout}
              location={location}
              homepage={homepage}
              shortcut={shortcut}
              topicId={this.props.topicId}
              shortcutPreference={this.props.shortcutPreference}
              setShortcutPreference={this.props.setShortcutPreference}
              selectedSidebarNav={this.props.selectedSidebarNav}
              selectedNav={selectedNav}
              isContentIntelligence={isContentIntelligence}
              isCatalogAnalysis={isCatalogAnalysis}
              isPerformanceAnalysis={isPerformanceAnalysis}
              isAIInsights={isAIInsights}
            />
            { (!this.props.shortcut && homepage && homepage.details && !homepage.details.is_attention_index) &&
              <NotFound isAdmin={this.props.isAdmin}/>
            }
            { (this.props.shortcut || (homepage && homepage.details && homepage.details.is_attention_index)) &&
              <GlobalAttentionComponent
                isAdmin={this.props.isAdmin}
                homepage={homepage}
                shortcut={shortcut}
                attentionIndexDetails={selectedView == ANTICIPATION_INDEX ? anticipationDetails : selectedView == TOP_CONTENT_INDEX ? topContentDetails : selectedView == TRENDING_INDEX ? trendingDetails : cancelledShows}
                //attentionIndexDetails={this.state.attentionIndexDetails}
                engagementWeeks={this.state.engagementWeeks}
                fetchAnticipationIndexDetails={fetchAnticipationIndexDetails}
                fetchTopContentIndexDetails={fetchTopContentIndexDetails}
                fetchTrendingIndexDetails={fetchTrendingIndexDetails}
                fetchCancelledShowsDetails={fetchCancelledShowsDetails}
                setSelectedAttentionIndexDate={setSelectedAttentionIndexDate}
                setSelecteddAttentionIndexView={setSelecteddAttentionIndexView}
                selectedDate={selectedDate}
              />
            }
          </>
        )
    }
}
function mapStateToProps () {
    const anticipationIndexSelector = makeAnticipationIndexDetailsSelector()
    const topContentIndexSelector = makeTopContentIndexDetailsSelector()
    const trendingIndexSelector = makeTrendingIndexDetailsSelector()
    const cancelledShowsSelector = makeCancelledShowsIndexDetailsSelector()
    return (state, ownProps) => {
      const profile = state.user.profile && new Profile(state.user.profile)
      const isAdmin = state.user.isAdmin
      const shortcut = ownProps.shortcut
      const homepage = state.homepage.list
      const selectedNav = state.sidebar.selectedNav
      const isContentIntelligence = state.sidebar.isContentIntelligence
      const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
      const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
      const anticipationDetails = anticipationIndexSelector(state, ownProps)
      const topContentDetails = topContentIndexSelector(state, ownProps)
      const trendingDetails = trendingIndexSelector(state, ownProps)
      const cancelledShows = cancelledShowsSelector(state, ownProps)
      const selectedDate = state.globalAttentionIndex.selectedDate
      const selectedView = state.globalAttentionIndex.selectedView
      const isAIInsights = state.sidebar.isAIInsights

      return {
        isAdmin,
        profile,
        shortcut,
        homepage,
        selectedNav,
        isContentIntelligence,
        isCatalogAnalysis,
        isPerformanceAnalysis,
        isAIInsights,
        anticipationDetails,
        topContentDetails,
        trendingDetails,
        cancelledShows,
        selectedDate,
        selectedView
      }
    }
  }
  function mapDispatchToProps (dispatch) {
    return {
      fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
      selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
      logout: () => dispatch(logout()),
      fetchAnticipationIndexDetails: (startDate, endDate) => dispatch(fetchAnticipationIndexIfNeeded(startDate, endDate)),
      fetchTopContentIndexDetails: (startDate, endDate) => dispatch(fetchTopContentIndexIfNeeded(startDate, endDate)),
      fetchTrendingIndexDetails: (startDate, endDate, previousStartDate, previousEndDate) => dispatch(fetchTrendingIndexIfNeeded(startDate, endDate, previousStartDate, previousEndDate)),
      fetchCancelledShowsDetails: (startDate, endDate) => dispatch(fetchCancelledShowsDetailsIfNeeded(startDate, endDate)),
      setSelectedAttentionIndexDate: (date) => dispatch(setSelectedAttentionIndexDate(date)),
      setSelecteddAttentionIndexView: (view) => dispatch(setSelecteddAttentionIndexView(view))
    }
  }
  export default connect(mapStateToProps, mapDispatchToProps)(GlobalAttentionContainer)